import * as React from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import { Button, CardActionArea, CardActions } from '@mui/material'
import useIntersectionObserver from '../userIntersectionObserver'
import './project_component.scss'

var everVisible = false
export default function EducationComponent (props) {
  const [ref, isVisible] = useIntersectionObserver(
    { threshold: 0.1 }, // Adjust the threshold as needed
    250 // Set the delay in milliseconds (e.g., 2000ms = 2 seconds)
  )
  if (isVisible) {
    everVisible = isVisible
  }
  return (
    <div ref={ref}>
      <Card
        sx={{
          maxWidth: 345,
          background: 'rgba(8, 16, 34, 0.15)',
          border: '1px solid rgba(255, 255, 255, 0.15)',
          backdropFilter: 'blur(20px)',
          borderRadius: '12px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
        }}
        style={{
          opacity: !everVisible ? '0' : '1',
          transition: 'all 0.5s',
          visibility: !everVisible ? 'hidden' : 'visible'
        }}
        className='project_card'
      >
        <CardActionArea>
          <div className='project_media_frame'>
          <CardMedia
            component='img'
            height='140'
            image={props.imagePath}
            alt={`Project of Sam Varghese: ${props.title}`}
            className='card_media'
          />
          </div>
          <CardContent>
            <Typography gutterBottom variant='h5' component='div'>
              {props.title}
            </Typography>
            <Typography
              gutterBottom
              variant='body2'
              component='div'
              color='#dce0e3'
              fontWeight='bold'
            >
              {props.title_sub_heading}
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              {props.description}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </div>
  )
}
